declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../../services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../services/actor.service';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { SaveMaterialBatchInfoRequest, SaveMaterialBatchRequest, GenericProcPostRequest, S_Methods, SaveMaterialBatchRequest2 } from '../../../../../../../src/app/ncs/models/actor/actor';

@Component({
  selector: 'ngbereturnmaterialbatch',
    templateUrl: './returnmaterialbatch.modal.html',
  styleUrls: ['./returnmaterialbatch.modal.scss']
})

export class NgbReturnMaterialbatchModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  public isRequesting: boolean;
  @Input() MaterialSpecName: string;
  @Input() EntryDate: Date;
  @Input() HsnCode: number;
  @Input() SupplierShortName: string;
  @Input() BatchNo: string;
  @Input() ExpiryDate: NgbDateStruct;
  @Input() TaxPercent: number;
  @Input() BatchQuantity: number;
  @Input() AvailableQuantity: number;
  @Input() MaterialBatchStorageCode: number;
  @Input() SupplierMaterialBatchCode: number;
  @Input() MaterialSpec: number;
  @Input() PurchaseUnitPrice: number;
  @Input() SellingPrice: number;
  public UpdatedBatchQuantity: number;
  public UpdatedAvailableQuantity: number;
  public UpdatedHsnCode: number;
  public UpdatedBatchNo: string;
  public UpdatedExpiryDate: NgbDateStruct;
  public UpdatedTaxPercent: number;
  public UpdatedPurchaseUnitPrice: number;
  public UpdatedSellingPrice: number;

  public ReturnQuantity: number;
  public Reason: string;
  public Remarks: string;

  //ExpiryDate: NgbDateStruct;
  public ApiResData: ApiResponseModel;
  CurrentSaveMaterialBatchInfoRequest: SaveMaterialBatchInfoRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    //this.CurrentSaveMaterialBatchInfoRequest = new SaveMaterialBatchInfoRequest();
    //this.CurrentSaveMaterialBatchInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.UpdatedBatchQuantity = this.BatchQuantity;
    this.UpdatedHsnCode = this.HsnCode;
    this.UpdatedBatchNo = this.BatchNo;
    this.UpdatedExpiryDate = this.ExpiryDate;
    this.UpdatedTaxPercent = this.TaxPercent;
    this.UpdatedAvailableQuantity = this.AvailableQuantity;
    this.UpdatedPurchaseUnitPrice = this.PurchaseUnitPrice;
    this.UpdatedSellingPrice = this.SellingPrice;
}

  SaveMaterial() {
    var saveReq = new SaveMaterialBatchRequest2();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40132;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ActionTag = "Save";
    //saveReq.DoccumentType = 101;

    saveReq.MaterialBatchStorage = this.MaterialBatchStorageCode;
    saveReq.SupplierMaterialBatchCode = this.SupplierMaterialBatchCode;
    saveReq.MaterialSpecCode = this.MaterialSpec;
    saveReq.HsnCode = this.HsnCode;
    saveReq.BatchNo = this.BatchNo;
    saveReq.AvailableQuantity = this.AvailableQuantity;
    saveReq.ReturnQuantity = this.ReturnQuantity;
    saveReq.Reason = this.Reason;
    saveReq.Remarks = this.Remarks;

    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40132;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  //onsubmit() {

  //  this.StartRefreshing();
  //  this.CurrentSaveMaterialBatchInfoRequest.ConditionalOperator = 10;
  //  this.CurrentSaveMaterialBatchInfoRequest.MaterialBatchStorageCode = this.MaterialBatchStorageCode;
  //  this.CurrentSaveMaterialBatchInfoRequest.SupplierMaterialBatchCode = this.SupplierMaterialBatchCode;
  //  this.CurrentSaveMaterialBatchInfoRequest.CurrBatchQty = this.BatchQuantity;
  //  this.CurrentSaveMaterialBatchInfoRequest.CurrAvailableQty = this.AvailableQuantity;
  //  this.CurrentSaveMaterialBatchInfoRequest.MaterialSpec = this.MaterialSpec;
  //  this.actorservice.SaveMaterialBatchInfo(this.CurrentSaveMaterialBatchInfoRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        if (this.ApiResData.Result > 0) {
  //          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

  //          this.activeModal.close();

  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParam("Invalid Operation...!");
  //          this.activeModal.close();

  //          this.stopRefreshing();

  //        }

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //          this.activeModal.close();


  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //          this.activeModal.close();
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();
  //        }
  //      }
  //    );

  //}
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
